import { capitilizeAll } from "./capitalize";

export function displayPlatform(platform: string) {
  const lowerCasePlatform = platform.toLowerCase().split("-")[0] ?? "";
  switch (lowerCasePlatform) {
    case "macos":
    case "darwin": {
      return "macOS";
    }
    case "ios": {
      return "iOS";
    }
    case "aix": {
      return "AIX";
    }
    default: {
      return capitilizeAll(lowerCasePlatform);
    }
  }
}
